import { FC } from 'react';

import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

const ActiveWithDelayedStart: FC<{ startAt: string | null }> = ({ startAt = '' }) => {
    const trl = useTrls();

    return (
        <>
            <div>{trl('campaign.actions.status.activeWithDelayedStart')}</div>
            <span>{startAt && formatDate(startAt, VIEW_DATE_FORMAT)}</span>
        </>
    );
};

export default ActiveWithDelayedStart;
